import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=3bfbbc4a&scoped=true&"
import script from "./ToolBar.vue?vue&type=script&lang=js&"
export * from "./ToolBar.vue?vue&type=script&lang=js&"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=3bfbbc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbbc4a",
  null
  
)

export default component.exports